import React from 'react';
import {Header,Item, Label,  Statistic, Breadcrumb, Table, Transition, Icon, Segment, Container, Loader, Dropdown, Divider, Form, Dimmer, Button, Grid,Input, Radio, Popup, List} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import moment from 'moment';
import ReactEcharts from "echarts-for-react";
import {moneda} from '../../util/';
 


const PagosPendientes=({ idCurso, pagoReporte, strings})=>{
    
	return (
        <Container>
        {idCurso<=0 || idCurso==null?"Seleccióne un curso":
         
            <Table  celled >
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>{strings?strings["alumno"]:""}</Table.HeaderCell>
                        <Table.HeaderCell>Fecha</Table.HeaderCell>
                        <Table.HeaderCell>Monto</Table.HeaderCell>    
                        <Table.HeaderCell>Status</Table.HeaderCell>    
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>
                        {pagoReporte.map(pago =>
								<Table.Row>
                                    <Table.Cell>{pago.alumno}</Table.Cell>
                                    <Table.Cell>{pago.fechaPago}</Table.Cell>  
                                    <Table.Cell>{pago.montoPago}</Table.Cell>
                                    <Table.Cell textAlign="center">
                                        <List.Item>
                                        <Popup
                                            trigger={
                                                <Icon name={pago.atrasado==1?'circle':'circle'} link  size="large" 
                                                    color={pago.atrasado==1?"red":"green"}  

                                                />
                                            }
                                            content={pago.atrasado==1?'Atrasado':'En tiempo'}
                                          />  




                                        </List.Item>
                                    </Table.Cell>
                                </Table.Row>
				        )}	
                    </Table.Body>
                  </Table> 
        }
        
        </Container>
	);
};



export default PagosPendientes;